import React from "react";
import { Button, Modal } from "reactstrap";
import TextInput from "components/TextInput";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const RemarkModal = ({
  open,
  onClose,
  confirmButtonLabel = "Submit",
  onConfirm
}) => {
  const [remark, setRemark] = React.useState("");

  const handleSubmit = () => {
    if (!remark) {
      toast.error("Remark is required!");
      return;
    } else {
      onConfirm(remark);
    }
  };

  return (
    <Modal zIndex={2000} centered isOpen={open} toggle={onClose}>
      <div className="text-center p-5">
        <TextInput
          placeholder="Enter Remark"
          onChange={(e) => setRemark(e.target.value)}
        />
        <div className="pt-4">
          <Button
            onClick={onClose}
            color="neutral-secondary"
            className="btn-pill mx-1">
            <span className="btn-wrapper--label">Cancel</span>
          </Button>
          <Button onClick={handleSubmit} color="primary" className="btn mx-1">
            <span className="btn-wrapper--label">{confirmButtonLabel}</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RemarkModal;

RemarkModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  confirmText: PropTypes.string,
  subText: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  icon: PropTypes.array
};
